import { render, staticRenderFns } from "./QuotationTab.vue?vue&type=template&id=134d3d17&scoped=true"
import script from "./QuotationTab.vue?vue&type=script&lang=js"
export * from "./QuotationTab.vue?vue&type=script&lang=js"
import style0 from "./QuotationTab.vue?vue&type=style&index=0&id=134d3d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d3d17",
  null
  
)

export default component.exports